/**
 * ═══════════════════════════════════════
 * Main.js — Entry point principal
 * ═══════════════════════════════════════
 *
 * Importa módulos y inicializa la interactividad general.
 * Vanilla JS (ES6+), sin jQuery.
 */

/* Importar estilos (procesados por Vite + Tailwind) */
import '../css/style.css';

/* Importar módulos */
import { inicializarGaleria } from './gallery.js';

/**
 * Inicializa el menú móvil responsive
 */
function inicializarMenuMovil() {
  const botonMenu = document.getElementById('menu-toggle');
  const menuMovil  = document.getElementById('menu-mobile');

  if ( ! botonMenu || ! menuMovil ) return;

  botonMenu.addEventListener('click', () => {
    const estaAbierto = menuMovil.classList.contains('max-h-screen');

    if ( estaAbierto ) {
      menuMovil.classList.remove('max-h-screen', 'opacity-100');
      menuMovil.classList.add('max-h-0', 'opacity-0');
      botonMenu.setAttribute('aria-expanded', 'false');
    } else {
      menuMovil.classList.remove('max-h-0', 'opacity-0');
      menuMovil.classList.add('max-h-screen', 'opacity-100');
      botonMenu.setAttribute('aria-expanded', 'true');
    }
  });

  /* Cerrar menú al hacer click fuera */
  document.addEventListener('click', (e) => {
    if ( ! botonMenu.contains(e.target) && ! menuMovil.contains(e.target) ) {
      menuMovil.classList.remove('max-h-screen', 'opacity-100');
      menuMovil.classList.add('max-h-0', 'opacity-0');
      botonMenu.setAttribute('aria-expanded', 'false');
    }
  });

  /* Submenús móviles: toggle expandir/colapsar */
  menuMovil.querySelectorAll('.mobile-submenu-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const submenu = btn.nextElementSibling;
      if ( ! submenu ) return;
      const isOpen = ! submenu.classList.contains('hidden');
      /* Cerrar todos los otros submenús */
      menuMovil.querySelectorAll('.mobile-submenu').forEach((s) => s.classList.add('hidden'));
      menuMovil.querySelectorAll('.mobile-submenu-toggle svg').forEach((c) => c.classList.remove('rotate-180'));
      if ( ! isOpen ) {
        submenu.classList.remove('hidden');
        btn.querySelector('svg').classList.add('rotate-180');
      }
    });
  });
}

/**
 * Inicializa scroll suave para enlaces internos
 */
function inicializarScrollSuave() {
  document.querySelectorAll('a[href^="#"]').forEach((enlace) => {
    enlace.addEventListener('click', (e) => {
      const destino = document.querySelector(enlace.getAttribute('href'));
      if ( destino ) {
        e.preventDefault();
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

/**
 * Agrega clase al header cuando se hace scroll
 */
function inicializarHeaderScroll() {
  const header = document.querySelector('.nav-primary');
  if ( ! header ) return;

  let ultimoScroll = 0;

  window.addEventListener('scroll', () => {
    const scrollActual = window.pageYOffset;

    if ( scrollActual > 50 ) {
      header.classList.add('nav-scrolled');
    } else {
      header.classList.remove('nav-scrolled');
    }

    ultimoScroll = scrollActual;
  }, { passive: true });
}

/**
 * Animación de elementos al entrar en viewport (Intersection Observer)
 */
function inicializarAnimaciones() {
  const elementos = document.querySelectorAll('[data-animate]');

  if ( ! elementos.length ) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if ( entry.isIntersecting ) {
        entry.target.classList.add('animate-fade-in');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px',
  });

  elementos.forEach((el) => {
    el.style.opacity = '0';
    observer.observe(el);
  });
}

/**
 * Inicialización principal — se ejecuta cuando el DOM está listo
 */
document.addEventListener('DOMContentLoaded', () => {
  inicializarMenuMovil();
  inicializarScrollSuave();
  inicializarHeaderScroll();
  inicializarAnimaciones();
  inicializarGaleria();
});
